export const COLORS = {
  primary: "#228be6",
  secondary: "#F4AC4A",
  white: "#FFFFFF",
  black: "#000",
  grey: "#F5F5F5",
  gray: "#606060",
  borderPrimary: "#D6D6D6",
  borderSecondary: "#EBEBEB",
  lightGrey: "#9A9A9A",
  inputBg: "#FAFAFA",
};
